export enum SampleType {
  UR = "UR",
  SD = "SD",
  SLD = "SLD",
}
